import hasLength from 'App/utils/hasLength';
import * as R from 'ramda';
import isActiveCategory from './isActiveCategory';

function hasActiveCategories(categories) {
    if (!hasLength(categories)) {
        return false;
    }
    return R.any(isActiveCategory, categories);
}

export default hasActiveCategories;
